import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/shared/Logo";
import { FOOTER_LINKS, COMPANY, PRACTICES } from "@/data/content";
import { MapPin, PhoneCall, Mail, ShieldCheck } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-border bg-card/40">
    <div className="section-x py-16">
      <div className="container-tmt">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
          <div>
            <Logo imgClassName="h-36 w-auto sm:h-40" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">
              The independent, buyer-side technology advisor. We help you {" "}
              <span className="text-foreground">drive success while you scale</span> â€” without vendor bias.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1.5 font-mono text-xs text-primary">
              <ShieldCheck className="h-3.5 w-3.5" /> 100% Supplier-Neutral
            </div>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Company</h4>
            <ul className="mt-4 space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground transition-colors hover:text-primary">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Practices</h4>
            <ul className="mt-4 space-y-3">
              {PRACTICES.slice(0, 5).map((p) => (
                <li key={p.slug}>
                  <Link to="/solutions" className="text-sm text-muted-foreground transition-colors hover:text-primary">{p.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Get in touch</h4>
            <ul className="mt-4 space-y-4 text-sm text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>{COMPANY.address}</span>
              </li>
              <li>
                <a href={COMPANY.phoneHref} className="flex items-center gap-3 transition-colors hover:text-primary">
                  <PhoneCall className="h-4 w-4 shrink-0 text-primary" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 transition-colors hover:text-primary">
                  <Mail className="h-4 w-4 shrink-0 text-primary" /> {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-border pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-xs text-muted-foreground">
            Â© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 font-mono text-xs text-muted-foreground">
            <Link to="/privacy" className="transition-colors hover:text-primary">Privacy Policy</Link>
            <p>Independent Â· Buyer-Side Â· Provider-Agnostic</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
